/* tslint:disable */
/* eslint-disable */
export enum Blocker {
  BUCKET_DISABLED,
  EMAIL_NOT_VERIFIED,
  NOT_FOUND
}
